import { ChangeRequestProgressInfo } from '@/types';

export type ChangeRequestReducer = ChangeRequestProgressInfo[] | null;

const initialState: ChangeRequestReducer = null;

const changeRequests = (state: ChangeRequestReducer = initialState, action) => {
    switch (action.type) {
        case 'BUYER_SET_CHANGE_REQUESTS':
            return action.data;
        case 'BUYER_SET_CHANGE_REQUEST':
            if (state === null) {
                return [action.data];
            }
            if (state.some((cr) => cr.changeRequestId === action.data.changeRequestId)) {
                return state.map((cr) => (cr.changeRequestId === action.data.changeRequestId ? action.data : cr));
            }
            return [...state, action.data];

        default:
            return state;
    }
};

export default changeRequests;